import {
  Timezone,
  ISODate,
  LocationType,
} from '@/entities';

interface IServiceEventListQuery {
  clientId?: string;
  meetingId?: string;
  meetingBatchId?: string;
}

interface ITimeSlotDateListQuery {
  timeSlotConfigId: string;
  startDate: ISODate;
  daysDuration: number;
  clientTimezone: Timezone;
  specialistId?: string;
}

interface ITimeSlotPeriodListQuery {
  specialistId: string;
  timeSlotConfigId: string;
  startDate: ISODate;
  daysDuration: number;
  clientTimezone: Timezone;
}

interface ITimeSlotConfigListQuery {
  locationType?: LocationType;
  offlineLocationId?: string;
  specialistId?: string;
}

interface IFirstAvailableTimeSlotPeriodQuery {
  timeSlotConfigId: string;
  specialistId?: string;
}

export const queryKeyFactory = {
  serviceEventList: (query?: IServiceEventListQuery) => {
    const base = ['SERVICE-EVENT', 'LIST'];
    return query ? [...base, query] : base;
  },
  user: (userId: string) => {
    return ['USER', userId];
  },
  companyMemberList: () => {
    return ['COMPANY-MEMBER', 'LIST'];
  },
  publicWebsite: (userId: string) => {
    return ['PUBLIC_WEBSITE', userId];
  },
  publicWebsiteUserIdDeprecated: (domain: string) => {
    return ['PUBLIC_WEBSITE_USER_ID_DEPRECATED', domain];
  },
  offlineLocationList: () => {
    return ['OFFLINE_LOCATION', 'LIST'];
  },
  meetingBookingSettings: (userId: string) => {
    return ['USER', userId, 'MEETING_BOOKING_SETTINGS'];
  },
  meetingCalendarLinks: (clientId: string, meetingId: string, timezone: string) => {
    return ['CLIENT', clientId, 'MEETING_CALENDAR_LINKS', meetingId, 'TIMEZONE', timezone];
  },
  firstAvailableTimeSlotPeriod: (query?: IFirstAvailableTimeSlotPeriodQuery) => {
    const base = ['FIRST_AVAILABLE_TIME_SLOT_PERIOD'];
    return query ? [...base, query] : base;
  },
  timeSlotDateList: (query?: ITimeSlotDateListQuery) => {
    const base = ['TIME_SLOT_DATE_LIST'];
    return query ? [...base, query] : base;
  },
  timeSlotPeriodList: (query?: ITimeSlotPeriodListQuery) => {
    const base = ['TIME_SLOT_PERIOD_LIST'];
    return query ? [...base, query] : base;
  },
  timeSlotConfigList: (query?: ITimeSlotConfigListQuery) => {
    const base = ['TIME_SLOT_CONFIG', 'LIST'];
    return query ? [...base, query] : base;
  },
  timeSlotConfig: (timeSlotConfigId: string) => {
    return ['TIME_SLOT_CONFIG', timeSlotConfigId];
  },
  jobConfig: (jobConfigId: string) => {
    return ['JOB_CONFIG', jobConfigId];
  },
  jobConfigList: () => {
    return ['JOB_CONFIG', 'LIST'];
  },
  jobConfigItems: (orderId: string) => {
    return ['JOB_CONFIG', 'ITEMS', orderId];
  },
  paymentAccount: () => {
    return ['PAYMENT_ACCOUNT'];
  },
  order: (orderId: string) => {
    return ['ORDER', orderId];
  },
  client: (clientId: string) => {
    return ['CLIENT', clientId];
  },
  detailedMeeting: (meetingId: string) => {
    return ['DETAILED_MEETING', meetingId];
  },
  detailedMeetingBatch: (meetingBatchId: string) => {
    return ['DETAILED_MEETING', 'BATCH', meetingBatchId];
  },
};
